var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHibooks4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 479,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "10.6 10.6 478.8 478.8",
    width: 479,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 502)",
    gradientUnits: "userSpaceOnUse",
    id: "a",
    x1: 248.069,
    x2: 251.679,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    y1: 530.545,
    y2: 9.836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d4fe0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    fill: "url(#a)",
    r: 239.4
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.4,75.1H131.9c-3.8,0-6.8,3-6.8,6.8V89c0,0.1,0,0.2,0,0.3s0,0.2,0,0.4V108c0,3.7,3,6.8,6.8,6.8h147.5 c3.8,0,6.8-3,6.8-6.8V81.9C286.2,78.1,283.2,75.1,279.4,75.1z M157.2,102.9H150c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8h7.3 c3.8,0,6.8,3,6.8,6.8C164,99.9,161,102.9,157.2,102.9z M266.1,102.9h-7.3c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8h7.3 c3.8,0,6.8,3,6.8,6.8C272.9,99.9,269.8,102.9,266.1,102.9z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.143
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.8,34.6h-64.2c-11.3,0-20.4,9.2-20.4,20.4v6.5h13.6V55c0-3.8,3.1-6.8,6.8-6.8h64.2c3.8,0,6.8,3,6.8,6.8 v6.5h13.6V55C258.2,43.7,249.1,34.6,237.8,34.6z",
    fill: "#2d4fe0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.7,116.6v84H257c-15,0-27.2,12.2-27.2,27.2v2.7h-12.5v-24.8c0-7.5-6.1-13.6-13.6-13.6h-14.9v-2.4 c0-7.5-6.1-13.6-13.6-13.6h-14.9v-5c0-7.5-6.1-13.6-13.6-13.6h-14.9c-0.1,0-0.3,0-0.4,0c-1.4-6-6.8-10.5-13.2-10.5h-14.9v-18.5 c0-3.8-3-6.8-6.8-6.8c-3.8,0-6.8,3-6.8,6.8v102c0,0.5,0,0.9,0.1,1.3c0,0.4,0.1,0.8,0.2,1.2c1,5.1,4.8,9.2,9.7,10.5 c0.4,0.1,0.8,0.2,1.2,0.3c0.4,0.1,0.8,0.1,1.2,0.2c0.5,0.1,0.9,0.1,1.3,0.1h126.3v20.6H96.1c-3.8,0-6.8,3-6.8,6.8 c0,3.7,3,6.8,6.8,6.8h133.6v27.1H96.4c-3.8,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8h133.4v27.1H96.6c-3.8,0-6.8,3-6.8,6.8 c0,3.7,3,6.8,6.8,6.8h133.1v27.1H96.9c-3.8,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8h132.9v15c0,5,1.3,9.6,3.6,13.6 c4.7,8.1,13.5,13.6,23.6,13.6H91.7c-18.8,0-34-15.2-34-34V116.6c0-18.8,15.3-34,34-34h19.8V108c0,11.2,9.1,20.4,20.4,20.4h147.5 c11.2,0,20.4-9.2,20.4-20.4V82.5h19.8C338.4,82.5,353.7,97.8,353.7,116.6z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "b",
    x1: 204.079,
    x2: 207.238,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    y1: 52.394,
    y2: 135.805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d4fe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69abf4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,81.9V108c0,11.2-9.2,20.4-20.4,20.4H131.9c-11.3,0-20.4-9.2-20.4-20.4V81.9c0-11.2,9.1-20.4,20.4-20.4 h147.5C290.7,61.5,299.9,70.6,299.9,81.9z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,96.1c0,3.8-3,6.8-6.8,6.8H150c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8h7.3 C161,89.3,164,92.4,164,96.1z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.143
  })), /*#__PURE__*/React.createElement("g", {
    id: "change1_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.9,96.1c0,3.8-3,6.8-6.8,6.8h-7.3c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8h7.3 C269.8,89.3,272.9,92.4,272.9,96.1z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.143
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffcc43",
    id: "change3_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.8,230.4V244H103.5c-0.5,0-0.9,0-1.3-0.1c-0.4,0-0.8-0.1-1.2-0.2c-0.4-0.1-0.8-0.2-1.2-0.3 c-4.9-1.4-8.7-5.5-9.7-10.5c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.1-0.9-0.1-1.3v-102c0-3.8,3-6.8,6.8-6.8c3.8,0,6.8,3,6.8,6.8 v102h14.9v0h13.6v0h14.9v0l13.6,0v0h14.9v0l13.6,0v0h14.9v0h13.6L229.8,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 230.4L118.3 230.4 118.3 230.4 103.5 230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9 230.4L146.8 230.4 146.8 230.4 131.9 230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8 230.4L203.7 230.4 203.7 230.4 188.8 230.4z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2d4fe0",
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1,232.9c0.9,5.1,4.7,9.2,9.7,10.5C94.9,242.1,91.1,238,90.1,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,160.5v69.9h-13.6l-14.9,0v-83.5h14.9c6.4,0,11.8,4.5,13.2,10.5C131.8,158.4,131.9,159.4,131.9,160.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change4_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.4,170.9v59.4l-13.6,0l-14.9,0v-69.9c0-1.1-0.1-2.1-0.4-3.1c0.1,0,0.2,0,0.4,0h14.9 C154.3,157.3,160.4,163.5,160.4,170.9z",
    fill: "#69abf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.8,189.6v40.8l-13.6,0h-14.9V176h14.9C182.7,176,188.8,182.1,188.8,189.6z",
    fill: "#2d4fe0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change4_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.3,205.6v24.8h-13.6l-14.9,0V192h14.9C211.2,192,217.3,198.1,217.3,205.6z",
    fill: "#69abf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change5_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.8,264.6v13.6H96.1c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8H229.8z",
    fill: "#ff8d23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change5_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.8,305.4V319H96.4c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8H229.8z",
    fill: "#ff8d23"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff8d23",
    id: "change5_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.8,346.1v13.6H96.6c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8H229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,355.4C232.3,355.4,232.3,355.4,232.3,355.4c0,0-0.1,0.1-0.2,0.2C232.2,355.5,232.2,355.5,232.3,355.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change5_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.8,386.8v13.6H96.9c-3.8,0-6.8-3-6.8-6.8c0-3.8,3-6.8,6.8-6.8H229.8z",
    fill: "#ff8d23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "c",
    x1: 218.402,
    x2: 429.946,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    y1: 469.833,
    y2: 203.163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8d23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.1,200.5H257c-15,0-27.2,12.2-27.2,27.2v132h0.1c-0.1,0.3-0.1,0.7-0.1,1v54.7c0,5,1.3,9.6,3.7,13.6 c4.7,8.1,13.5,13.6,23.6,13.6h158.2c15,0,27.2-12.2,27.2-27.2V227.7C442.3,212.7,430.1,200.5,415.1,200.5z M428.7,415.4 c0,7.5-6.1,13.6-13.6,13.6H257c-7.5,0-13.6-6.1-13.6-13.6V227.7c0-7.5,6.1-13.6,13.6-13.6h158.2c7.5,0,13.6,6.1,13.6,13.6V415.4z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "d",
    x1: 336.278,
    x2: 335.736,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    y1: 278.521,
    y2: 429.268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d4fe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69abf4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.7,278.9v136.5c0,7.5-6.1,13.6-13.6,13.6H257c-7.5,0-13.6-6.1-13.6-13.6V278.9H428.7z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.8,304.4v35.2c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.2c0-6.6,5.4-12,12-12h25.6 C355.4,292.4,360.8,297.8,360.8,304.4z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.8,376.8V412c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.3c0-6.6,5.4-12,12-12h25.6 C355.4,364.8,360.8,370.2,360.8,376.8z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.4,304.4v35.2c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.2c0-6.6,5.4-12,12-12h25.6 C416,292.4,421.4,297.8,421.4,304.4z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.4,376.8V412c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.3c0-6.6,5.4-12,12-12h25.6 C416,364.8,421.4,370.2,421.4,376.8z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,304.4v35.2c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.2c0-6.6,5.4-12,12-12H289 C295.6,292.4,301,297.8,301,304.4z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,376.8V412c0,6.6-5.4,12-12,12h-25.6c-6.6,0-12-5.4-12-12v-35.3c0-6.6,5.4-12,12-12H289 C295.6,364.8,301,370.2,301,376.8z",
    fill: "#ffcc43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.1,214.1H257c-7.5,0-13.6,6.1-13.6,13.6v51.1h185.4v-51.1C428.7,220.2,422.6,214.1,415.1,214.1z M396.3,268H277.4c-12.2,0-22.1-9.9-22.1-22.1c0-12.4,9.9-22.3,22.1-22.3h118.9c12.2,0,22.1,9.9,22.1,22.1 C418.4,258.1,408.5,268,396.3,268z",
    fill: "#69abf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.4,245.7c0,12.4-9.9,22.3-22.1,22.3H277.4c-12.2,0-22.1-9.9-22.1-22.1c0-12.4,9.9-22.3,22.1-22.3h118.9 C408.5,223.6,418.4,233.5,418.4,245.7z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibooks4);
export default __webpack_public_path__ + "static/media/hibooks4.605f9c5e39ea9dbb7e74cb2e3c51f379.svg";
export { ForwardRef as ReactComponent };